import { render, staticRenderFns } from "./TestLicenseInquiries.vue?vue&type=template&id=782846b8&scoped=true&"
import script from "./TestLicenseInquiries.vue?vue&type=script&lang=js&"
export * from "./TestLicenseInquiries.vue?vue&type=script&lang=js&"
import style0 from "./TestLicenseInquiries.vue?vue&type=style&index=0&id=782846b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782846b8",
  null
  
)

export default component.exports